import { INFORMED_BEFOREHAND_TO_DAYS_MAP } from "../settings/constants";
import { InformedBeforehand } from "../modules/types/intake-funnel";

export function informedBeforehandToDays(informedBeforehand: InformedBeforehand) {
  return INFORMED_BEFOREHAND_TO_DAYS_MAP[informedBeforehand];
}
